/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CommandService, CommandStrategy, EventService, UserIdService } from '@spartacus/core';
import { OrderConnector, OrderService } from '@spartacus/order/core';
import { Order, OrderPlacedEvent } from '@spartacus/order/root';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class AimoOrderService extends OrderService {
    protected placedOrder$ = new BehaviorSubject<Order | undefined>(undefined);

    constructor(
        protected activeCartFacade: ActiveCartFacade,
        protected userIdService: UserIdService,
        protected commandService: CommandService,
        protected orderConnector: OrderConnector,
        protected eventService: EventService,
    ) {
        super(activeCartFacade, userIdService, commandService, orderConnector, eventService);
        this.placeOrderCommand = this.commandService.create<boolean, Order>(
            (payload) =>
                this.checkoutPreconditions().pipe(
                    switchMap(([userId, cartId]) =>
                        this.orderConnector.placeOrder(userId, cartId, payload).pipe(
                            tap((order) => {
                                this.placedOrder$.next(order);
                                this.eventService.dispatch(
                                    {
                                        userId,
                                        cartId,
                                        /**
                                         * As we know the cart is not anonymous (precondition checked),
                                         * we can safely use the cartId, which is actually the cart.code.
                                         */
                                        cartCode: cartId,
                                        order,
                                    },
                                    OrderPlacedEvent,
                                );
                            }),
                        ),
                    ),
                ),
            {
                strategy: CommandStrategy.Parallel, //Aimo change: run in parallel, catch duplicates in backend
            },
        );
    }

    placeOrder(termsChecked: boolean): Observable<Order> {
        return this.placeOrderCommand.execute(termsChecked);
    }
}
